import React, { useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import UserForm from '../../User/UserForm';

export default function UserEditPage({
	get_user_endpoint,
	update_user_endpoint
}) {
	const { id } = useParams();
	const location = useLocation();

	// Access the state passed from the Link
	const isEditing = location.state ? location.state.isEditing : '';

	useEffect(
		() => {
			// console.log('Received id:', id);
			// console.log('Received isEditing:', isEditing);
		},
		[
			id,
			isEditing
		]
	);

	return (
		<div>
			<UserForm
				id={id}
				isEditing={isEditing}
				get_user_endpoint={get_user_endpoint}
				update_user_endpoint={update_user_endpoint}
			/>
		</div>
	);
}

UserEditPage.propTypes = {
	get_user_endpoint: PropTypes.string.isRequired,
	update_user_endpoint: PropTypes.string.isRequired
};
